import AccountCreationFormContainer from './AccountCreationFormContainer';

export default AccountCreationFormContainer;
